module.exports = __webpack_public_path__ + "img/2.409af67.jpg";